export const handleAriaLabel = ['Minimum price', 'Maximum price']
